import { defineComponent as _defineComponent } from 'vue'
import { useApi } from "@/plugins/api/api";
import { ref, computed, watch, onMounted } from "vue";
import { WorkSchedule, WeekDay } from "../UserMasterWorkSchedule";
import { InputRules } from "@/rules";
import { DateTime } from "luxon";

type ShiftPattern = {
  shiftPatternId: number;
  shiftPatternName: string;
  abbreviation: string;
  startTime: string;
  endTime: string;
  breakTime: string;
  morningBreakTime: string;
  midnightBreakTime: string;
  opeTime: string;
};

type Props = {
  value: WorkSchedule;
  affiliationId?: number;
  items: WorkSchedule[];
};
type Emits = {
  (e: "input", value: WorkSchedule): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkScheduleForm',
  props: {
    value: null,
    affiliationId: null,
    items: null
  },
  emits: ["input"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: "input", value: WorkSchedule): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: WorkSchedule;
  affiliationId?: number;
  items: WorkSchedule[];
};

const { $get, Paths } = useApi();

const weekday = [
  { value: WeekDay.Monday, text: "月" },
  { value: WeekDay.Tuesday, text: "火" },
  { value: WeekDay.Wednesday, text: "水" },
  { value: WeekDay.Thursday, text: "木" },
  { value: WeekDay.Friday, text: "金" },
  { value: WeekDay.Saturday, text: "土" },
  { value: WeekDay.Sunday, text: "日" }
] as const;

const weeks = [
  { value: "week1", text: "1週" },
  { value: "week2", text: "2週" },
  { value: "week3", text: "3週" },
  { value: "week4", text: "4週" },
  { value: "week5", text: "5週" }
] as const;

const sqlToDateTime = (str?: string) => {
  if (str) {
    const dateTime = DateTime.fromSQL(str);
    if (dateTime.isValid) return dateTime;
  }
  return undefined;
};

const diffTime = (start?: string, end?: string, format = "hh:mm") => {
  const startTime = sqlToDateTime(start);
  const endTime = sqlToDateTime(end);
  if (startTime && endTime) {
    const duration = endTime.diff(startTime);
    if (duration.isValid) return duration.toFormat(format);
  }
  return undefined;
};




const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

const chip = computed({
  get: () => weeks.flatMap(e => (props.value[e.value] === "1" ? e.value : [])),
  set: value => {
    weeks.forEach(e => (props.value[e.value] = "0"));
    value.forEach(e => (props.value[e] = "1"));
  }
});

const shiftItems = ref<ShiftPattern[]>([]);

const workTime = computed(() => {
  console.log(props.value.shiftPatternId);
  const val = modelValue.value;
  return diffTime(val.restTime, diffTime(val.startTime, val.endTime));
});

watch(
  () => props.value.shiftPatternId,
  val => {
    const item = shiftItems.value.find(e => e.shiftPatternId === val);
    modelValue.value.shiftPatternName = `${item?.shiftPatternName} ${item?.abbreviation}`;
    modelValue.value.startTime = item?.startTime;
    modelValue.value.endTime = item?.endTime;
    modelValue.value.restTime = item?.breakTime;
    modelValue.value.diffTime = diffTime(
      item?.breakTime,
      diffTime(item?.startTime, item?.endTime)
    );
  }
);

const itemValue = "shiftPatternId";
const itemText = (e: ShiftPattern) => {
  return `${e.shiftPatternName} ${e.abbreviation}`;
};

const getShiftPattern = async () => {
  const result = await $get<ShiftPattern[]>(
    `${Paths.userMaster.workSchedule.shift}/${props.affiliationId}`
  );
  if (result) shiftItems.value = result;
};

const duplicated = () => {
  const weekday = props.value.weekday;
  const shiftPatternId = props.value.shiftPatternId;
  const isDuplicated = props.items.some(
    e => e.weekday === weekday && e.shiftPatternId === shiftPatternId
  );
  return !isDuplicated || "シフトが重複しています。";
};

onMounted(async () => {
  await getShiftPattern();
});

const vform = ref();

const validate = (): boolean => vform.value?.validate();
const reset = (): void => vform.value?.reset();
const resetValidation = (): void => vform.value?.resetValidation();

expose({
  validate,
  reset,
  resetValidation
});

watch(
  () => props.value.weekday,
  () => {
    validate();
  }
);

return { __sfc: true,$get, Paths, weekday, weeks, sqlToDateTime, diffTime, props, emits, modelValue, chip, shiftItems, workTime, itemValue, itemText, getShiftPattern, duplicated, vform, validate, reset, resetValidation, InputRules }
}

})